// @flow
import moment from 'moment';
import api from 'common/services/api';
import Radio from 'common/domain/radio';
import Connector from '../domain/Connector';

type LastSyncTimeResponse = {
  syncTime: string,
}

class ConnectorsAPI {

  buildHeaders = (token: string): Object => ({ Authorization: 'Bearer ' + token });

  async fetchAllFor(radio: Radio, token: string): Promise<Array<Connector>> {
    const { data } = await api.get(`/statsradio/${radio.callSign}/connectors`, {}, { headers: this.buildHeaders(token) });

    return data.map(connector => Connector.parse(connector));
  }

  async fetchLastSyncMoment(radio: Radio, token: string): Promise<moment> {
    const { data }: { data: LastSyncTimeResponse } = await api.get(
      `/statsradio/${radio.callSign}/connectors/last-sync`,
      {},
      { headers: this.buildHeaders(token) },
    );

    return moment(data.syncTime);
  }
}

export default new ConnectorsAPI();



// WEBPACK FOOTER //
// ./src/statsradio/modules/connectors/services/ConnectorsAPI.js